import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

@Injectable()
export class GetSupplyPromoteMarkDivListService extends PlessJsonResponderSub<any> {

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplyPromoteMarkDivListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunc=null]
   * @memberof GetSupplyPromoteMarkDivListService
   */
  execute(successFunc: Function = null): void {
    this.successFunc = successFunc;
    this.send('getSupplyPromoteMarkDivList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplyPromoteMarkDivListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
